import { render } from "./App.vue?vue&type=template&id=e5f6176e&lang=pug"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e5f6176e&lang=sass"

import exportComponent from "/Users/ajacob22/DAC/trml_spa/trml-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__